import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import EffettuaLogin from './Aree/EffettuaLogin';
import { getParams } from './Utils';

const Area = {
  LOGIN: 1,
  AUTO_LOGIN: 2,
};

const QueryStringHandler = ({ applicationStyle }) => {
  const {
    referer, scope, login, client, credenziali,
  } = getParams(window.location.href);

  const [area, setArea] = useState(null);

  useEffect(() => {
    if (referer && scope && client) {
      if (login) {
        setArea(Area.LOGIN);
      } else {
        setArea(Area.SCOPES);
      }
    } else if (referer && credenziali) {
      setArea(Area.AUTO_LOGIN);
    } else if (referer) {
      setArea(Area.LOGIN);
    }
  }, [client, credenziali, login, referer, scope]);

  return (
    <>
      {area === Area.LOGIN && (
        <EffettuaLogin
          referer={referer}
          client={client}
          applicationStyle={applicationStyle}
        />
      )}
      {area === Area.AUTO_LOGIN && (
        <EffettuaLogin
          credenziali={credenziali}
          referer={referer}
          client={client}
          applicationStyle={applicationStyle}
        />
      )}
    </>
  );
};

QueryStringHandler.propTypes = {
  applicationStyle: PropTypes.shape({}).isRequired,
};

export default QueryStringHandler;
